export { default } from './LoadMore'
